import { Button, Close } from '@bphxd/ds-core-react';
import { FC, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import classes from '../JobFiltersModal/JobFiltersModal.module.scss';
import { EMPTY_PERMIT_FILTERS } from '../../../lib/constants';
import Select from 'react-select';
import { ReactSelectOverrides } from '@bphxd/ds-core-react';
import { optionsFromEnum, stringToOption } from '../../../lib/util/format';
import { TASK_WORK_CENTER_OPTIONS } from '../../../lib/constants/dbConstants';
import clsx from 'clsx';
import { Trash24 } from '@bphxd/ds-core-react/lib/icons';
import { TAspectsTableFilters } from '../AspectsTable/AspectsTable';
import {
  getEventOptions,
  getAugmentedOptionsFromMapping as getOptions,
  getPermitOptions,
} from '../JobFiltersModal/JobFiltersModal.util';
import { useSelectedAsset } from '../../../lib/util';
import { useQuery } from '@apollo/client';
import { GET_EVENTS_BY_ASSET } from '../../../graph-queries/tar/event';
import { TEvent } from '../../../lib/types';

export type TPermitFilters = TAspectsTableFilters<
  'ecowPermit.statusComment' | 'taskWorkCenter' | 'gocSh1' | 'permitOwner' | 'event'
>;



const TPermitFiltersModal: FC<{
  defaultValues: TPermitFilters;
  onSubmit: (filters: TPermitFilters) => unknown;
  onClose: () => void;
}> = ({ defaultValues, onSubmit, onClose }) => {
  const [filters, setFilters] = useState<TPermitFilters>(defaultValues);

  const setFilterByKey = (key: keyof TPermitFilters, values: string[]) => {
    setFilters((filters) => ({ ...filters, [key]: values }));
  };
  const handleSubmit = () => {
    onSubmit(filters);
    onClose();
  };

  const handleDelete = () => {
    onSubmit(EMPTY_PERMIT_FILTERS);
    onClose();
  };
  const asset = useSelectedAsset();
  const { data, loading } = useQuery(GET_EVENTS_BY_ASSET, {
    variables: { assetId: asset?.assetId || -1 },
    skip: !asset?.assetId,
  });
  const events = data?.eventsByAssetId as TEvent[];

  return (
    <Modal isOpen toggle={onClose} className="modal-dialog-centered">
      <ModalHeader className="border-0 px-6" close={<Close onClick={onClose} />}>
        Filter Permits
      </ModalHeader>
      <ModalBody className={clsx('p-6 pt-0', classes.root)}>
        <div className={classes.filters}>
          <Form className="row g-5">
            {/* <div className="col-md-6">MO Status</div> */}
            <div className="col-md-6">
              <FormGroup>
                <Label>Event</Label>
                <Select
                  defaultValue={filters.event.map(stringToOption)}
                  isMulti
                  options={getEventOptions(asset, events).map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'event',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Permit Status</Label>
                <Select
                  defaultValue={filters['ecowPermit.statusComment'].map(stringToOption)}
                  isMulti
                  options={getPermitOptions().map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'ecowPermit.statusComment',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Work Center</Label>
                <Select
                  defaultValue={filters.taskWorkCenter.map(stringToOption)}
                  isMulti
                  options={TASK_WORK_CENTER_OPTIONS}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'taskWorkCenter',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Permit Owner</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'Jim,Stuart'. Values need to be exact."
                  name="permitOwner"
                  id="permit-owner"
                  defaultValue={filters.permitOwner}
                  onChange={(e) => {
                    const permitOwnerArrary: string[] = e.target.value.split(',');
                    setFilterByKey('permitOwner', permitOwnerArrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>SH1</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'A123,B456'. Values need to be exact."
                  name="gocSh1"
                  id="goc-sh1"
                  defaultValue={filters.gocSh1}
                  onChange={(e) => {
                    const gocSh1Arrary: string[] = e.target.value.split(',');
                    setFilterByKey('gocSh1', gocSh1Arrary);
                  }}
                />
              </FormGroup>
            </div>
            {/* Footer */}
            <div className={clsx('col-md-12', classes.footer)}>
              <Button
                size="lg"
                className=""
                theme="darker"
                level="tertiary"
                onClick={handleDelete}
                Icon={Trash24}
              >
                Remove Filters
              </Button>
              <Button
                disabled={filters === defaultValues}
                size="md"
                className=""
                theme="darker"
                level="primary"
                onClick={handleSubmit}
              >
                Apply Filters
              </Button>
            </div>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TPermitFiltersModal;
